import React, { Fragment } from 'react'
import Freevoucher from './Freevoucher'

const FreeVoucher = () => {
  return (
    <Fragment> <Freevoucher/></Fragment>
  )
}

export default FreeVoucher